import type { CaptureFileJSONObject } from '@ikegps/core-api';
import { IkeFieldType } from '@ikegps/core-api';
import type { FormModelField } from '../../form/form.field';
import { CollectionModelField, ModelMutator } from '../collection.field';
import { registerFieldType } from './field.registry';
import type { CaptureProvider } from './provider/capture.provider';

export class ModelMutatorImage extends ModelMutator<FormModelField, CollectionModelFieldImage> {
	add(captureId: string) {
		const stateValue = this.field.stateValue || [];

		// Don't add existing captures twice.
		const index = stateValue.indexOf(captureId);
		if (index > -1) {
			return;
		}

		this.state.setFieldValue(this.field.id, [...stateValue, captureId]);
	}

	override copy(from: CollectionModelFieldImage): boolean {
		for (const capture of from.getCaptures()) {
			this.add(capture.objectId);
		}

		return true;
	}
}

export class CollectionModelFieldImage
	extends CollectionModelField<FormModelField, string[]>
	implements CaptureProvider
{
	static TYPE: IkeFieldType = IkeFieldType.IMAGE;

	static isImageField(f: CollectionModelField): f is CollectionModelFieldImage {
		return f.schema.type === CollectionModelFieldImage.TYPE;
	}

	private _Mutator: ModelMutatorImage;
	get Mutator() {
		if (this._Mutator == null) {
			this._Mutator = new ModelMutatorImage(this);
		}
		return this._Mutator;
	}

	override get value(): CaptureFileJSONObject[] {
		return this.getCaptures();
	}

	getOwnedCaptureIds(): string[] {
		return this.getCaptureIds();
	}

	getCaptureIds(): string[] {
		const stateValue = this.stateValue;
		if (stateValue == null) {
			return [];
		}
		return stateValue;
	}

	getOwnedCaptures(): CaptureFileJSONObject[] {
		return this.getCaptures();
	}
	getCaptures(): CaptureFileJSONObject[] {
		return this.getCaptureIds()
			.map((c) => this.collection.state.getCapture(c))
			.filter((c) => !!c);
	}

	hasValue(): boolean {
		return this.value.length > 0;
	}
}

registerFieldType(IkeFieldType.IMAGE, (parent, schema) => new CollectionModelFieldImage(parent, schema));
